import { cloneDeep } from 'lodash';

export class DocumentModelFactoryServiceStub {
  build() {
    return {};
  }

  copy(source: any) {
    return cloneDeep(source);
  }
}
